// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"BannerH_TheComp__Z1LY6"};